// extracted by mini-css-extract-plugin
export default {"main":"styles_main__drLC9","img":"styles_img__gTLfp","data":"styles_data__2PnuU"};